const CustomPopupBox = ({
  heading1,
  heading2,
  descrText1,
  descrText2,
  descrText3,
  handleAction,
  handleContinue,
  btnTxt1,
  btnTxt2,
  imgSrc,
  imgClass,
  headingClass,
  descrClass,
  errorMsg,
}) => {
  return (
    <div className="popUpContainer">
      <div className="popUpInner">
        <div className="popupBox noBorder">
          <div className="logoContainer">
            <div className={imgClass} style={{ background: "none" }}>
              <img src={imgSrc} />
            </div>
            <div className="popupHeader">
              <span className={headingClass}>{heading1}</span>
              <span className={headingClass}>{heading2}</span>
            </div>
          </div>

          <div className="contentContainer">
            <span className={descrClass}>{descrText1}</span>
            <span className={descrClass}>{descrText2}</span>
            <span className={descrClass}>{descrText3}</span>
            <span className="errorMsg">{errorMsg}</span>
          </div>

          <div className="btnContainer">
            {handleAction && (
              <button
                onClick={() => handleAction()}
                className="btnGolden"
                style={{
                  padding: "10px 61px",
                  width: "327px",
                  cursor: "pointer",
                }}
                type="button"
              >
                {btnTxt1}
              </button>
            )}

            {handleContinue && (
              <button
                onClick={() => handleContinue()}
                className="btnTransparent"
                style={{
                  marginTop: "16px",
                  width: "327px",
                  cursor: "pointer",
                }}
                type="button"
              >
                {btnTxt2}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomPopupBox;
